obsQueryFields